import AppAxios from './axios';
import jwt from 'jsonwebtoken';
import moment from 'moment';
import AppDevice from './device';

let s = "Medicaltec3101"

class StudyItem {
    constructor(obj){
        this.ID = obj.ID
        this.FECHA = obj.FECHA
        this.NOMBRE = obj.NOMBRE
        this.SEXO = obj.SEXO
        this.PAS_ID = obj.PAS_ID
        this.EST_UID = obj.EST_UID
        this.INFORM = obj.INFORM
        this.SERIES = obj.SERIES
        this.PAS_BD = obj.PAS_BD
    }
    getmodalidad(){
        let mod
        let modtest = FindModality(this)
        switch (modtest) {
          case "CT":
            mod = "Tomografia";
            break;
          case "MR":
            mod = "Resonancia";
            break;
          case "US":
            mod = "Ecografia";
            break;
          case "CR":
            mod = "Rayos x";
            break;
          case "DX":
            mod = "Rayos x DR";
            break;
          case "MG":
            mod = "Mamografia";
            break;
          default:
            mod = modtest;
            break;
        }
        return mod
    }
    getmodalidadfull(){
        let mod
        let modtest = FindModality(this)
        switch (modtest) {
          case "CT":
            mod = "Tomografia";
            break;
          case "MR":
            mod = "Resonancia";
            break;
          case "US":
            mod = "Ecografia";
            break;
          case "CR":
            mod = "Rayos x";
            break;
          case "DX":
            mod = "Rayos x DR";
            break;
          case "MG":
            mod = "Mamografia";
            break;
          default:
            mod = modtest;
            break;
        }
        return {dicom:modtest,texto:mod}
    }
    getsexo(){
        return this.SEXO
    }
    namecomplement(){
      switch(AppDevice.AppSetings.NameComplement){
        case "id_patient":
          return this.PAS_ID
        case "age":
          return this.calcage()
        default:
          return ""
      }
    }
    colorsexo(){
        let color
        switch (this.SEXO) {
            case "M":
                color="#025185"
                break;
            case "F":
                color="#ed0558"
                    break;
            default:
                color="#9ea7aa"
                break;
        }
        return color
    }
    getnombre(){
        let array = this.NOMBRE
        let nombre = ''
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if(element === "^"){
                nombre = nombre + " "
            }else{
                nombre = nombre + element
            }
        }
        return nombre
    }
    getfecha(){
        return moment(this.FECHA,"YYYYMMDD").format("DD/MM/YYYY")
    }
    calcage(){
        if(this.PAS_BD === undefined){
            return "0A"
        }
        const studydate = moment(this.FECHA,"YYYYMMDD")
        const birthdate = moment(this.PAS_BD,"YYYYMMDD")
        let edad = studydate.diff(birthdate,'years')
        return `${edad}A`
    }
    filtrar(filtro){
        if(this.NOMBRE.toUpperCase().indexOf(filtro.toUpperCase()) > -1 || this.PAS_ID.indexOf(filtro.toUpperCase()) > -1){
            return true
        }else{
            return false
        }
    }
    filtrarmod(mods){
        if(mods.indexOf(this.getmodalidadfull().dicom) > -1){
            return false
        }else{
            return true
        }
    }
    ShareWP(envio){
        let token = jwt.sign({ID:this.ID},s,{expiresIn:`${envio.tiempo}h`})
        let mensaje = escribirmensaje(token,this.getmodalidad(),this.getnombre())
        if(envio.numero !== ""){
            window.open(`https://api.whatsapp.com/send/?phone=${envio.prefijo}${envio.numero}&text=${mensaje}&type=phone_number&app_absent=0`,'_blank')
        }else{
            alert("numero telefonico invalido")
        }
        return true
    }
    ShareMail(envio){
        return new Promise((Pres,Prej)=>{
            let token = jwt.sign({ID:this.ID},s,{expiresIn:`${envio.tiempo}h`})
            let data = {
                destino:envio.direccion,
                data:`${AppDevice.ExternalServer}/externo/${token}`,
                nombre:this.getnombre(),
                modalidad:this.getmodalidad(),
                institucion:AppDevice.InstitutionName
            }
            if(envio.direccion !== ""){
                Pres(data)
            }else{
                Prej(false)
            }
        })
    }
    ShareQR(){
        let token = jwt.sign({ID:this.ID},s,{expiresIn:"48h"})
        let url = `${AppDevice.ExternalServer}/externo/${token}`
        return(url)
    }
    ShareWPcontacto(contacto){
        let token = jwt.sign({ID:this.ID},s,{expiresIn:"48h"})
        let mensaje = escribirmensaje(token,this.getmodalidad(),this.getnombre())
        if(contacto.numero !== ""){
            window.open(`https://api.whatsapp.com/send/?phone=${contacto.prefijo}${contacto.telefono}&text=${mensaje}&type=phone_number&app_absent=0`,'_blank')
        }else{
            alert("numero telefonico invalido")
        }
        return true
    }
    ShareMailcontacto(contacto){
        let token = jwt.sign({ID:this.ID},s,{expiresIn:"48h"})
        let data = {
            destino:contacto.correo,
            data:`${AppDevice.ExternalServer}/externo/${token}`,
            nombre:this.getnombre(),
            modalidad:this.getmodalidad()
        }
        return data
    }
    Abririmagenes(filtros){
        window.sessionStorage.setItem("filtrosmain",JSON.stringify({fecahs:filtros.RangoFechasSt,mod:filtros.FiltroModalidades}))
        window.sessionStorage.setItem('EstudioVisor',JSON.stringify(this))
    }
    json(){
        return {
            ID:this.ID,
            FECHA:this.FECHA,
            NOMBRE:this.NOMBRE,
            SEXO:this.SEXO,
            PAS_ID:this.PAS_ID,
            EST_UID:this.EST_UID,
            SERIES:this.SERIES
        }
    }
    async uploadinform(informe){
        let formdata = new FormData()
        formdata.append('files',informe)
        formdata.append('estudio',JSON.stringify(this.json()))
        formdata.append('fechasubida',new Date())
        try{
            let res = await AppAxios.post("/cargarInforme",formdata)
            return (res.data)
        }
        catch(e){
            throw e
        }
    }
    static async GetList(fechas,abortsignal) {
        let res
        try{
            res = await AppAxios.get(`/getestudios?inicio=${fechas.inicio}&final=${fechas.final}`, { signal: abortsignal });
        } catch (error) {
            console.log(error)
        }
        let Estudios = []
        for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            let estudio = new StudyItem(element)
            Estudios.push(estudio)
        }
        return Estudios
    }
}

function escribirmensaje(token,modalidad,NOMBRE){
    //let mensaje = `Hola%20${NOMBRE},%0A%0ADesde%20${AppDevice.InstitutionName}%20te%20enviamos%20tu%20estudio%20de%20${modalidad}.%20Puedes%20acceder%20a%20él%20fácilmente%20a%20través%20del%20siguiente%20enlace:%0A%0A${AppDevice.ExternalServer}/externo/${token}%0A%0ASi%20tienes%20alguna%20duda%20o%20necesitas%20asistencia,%20no%20dudes%20en%20contactarnos.%20Estamos%20aquí%20para%20ayudarte.%0A%0A¡Gracias%20por%20confiar%20en%20nosotros!%0A%0AUn%20cordial%20saludo,%0AEl%20equipo%20de%20${AppDevice.InstitutionName}`
    let mensaje = AppDevice.WPM
    mensaje = mensaje.replaceAll("[[SERVER_URL]]",AppDevice.ExternalServer)
    mensaje = mensaje.replaceAll("[[TOKEN]]",token)
    mensaje = mensaje.replaceAll("[[MODALIDAD]]",modalidad)
    mensaje = mensaje.replaceAll("[[NOMBRE]]",NOMBRE)
    console.log(mensaje)
    return mensaje
}

function FindModality(study){
    let mod = study.SERIES[0].MODALIDAD
    for (let i = 0; i<study.SERIES.length; i++){
        if(study.SERIES[i].MODALIDAD !== "OT" || study.SERIES[i].MODALIDAD !== "SR"){
            mod = study.SERIES[i].MODALIDAD
            break
        }
    }
    return mod
}

export default StudyItem;